import { searchEvent } from "@src/analytics";

/* 
window.dataLayer.push({
  "event": "search",
  "search_category": "keyword",
  "selected_term": "Tokyo-to"
});
*/
export function anaClickSearch(
  anchor?: HTMLAnchorElement,
  input?: HTMLInputElement
) {
  // only trigger once per action
  if (!anchor || anchor.parentElement?.dataset.empty !== undefined) {
    searchEvent({
      search_category: "keyword",
      selected_term: input?.value ?? undefined,
    });
  } else {
    searchEvent({
      search_category: "keyword",
      selected_term: anchor?.children?.item(0)?.textContent ?? undefined,
    });
  }
}
